module.exports = __webpack_public_path__ + "static/media/globalshopping-banner.b92a5f9c.png";